export default __webpack_public_path__ + "images/0x841fad6eae12c286d1fd18d1d525dffa75c7effe.png";